/**
 * Cwiggo SDK initialization for the Refine application
 * Simple wrapper that initializes the SDK once during app startup
 */

let sdkInstance: any = null;
let isInitialized = false;

/**
 * Initialize the Cwiggo SDK - exported for app startup
 */
export async function initializeCwiggoSDK() {
  return await initializeSDK();
}

/**
 * Initialize the Cwiggo SDK - call this once during app startup
 */
async function initializeSDK() {
  if (isInitialized) return sdkInstance;

  // Only initialize in browser environment
  if (typeof window === "undefined") {
    console.warn("SDK not available in server environment");
    return null;
  }

  try {
    // Import only browser-safe functions
    const sdk = await import("@cwiggo/sdk");

    // Create a browser-safe instance with only the functions you need
    sdkInstance = {
      helloWorld: sdk.helloWorld,
      // Add other browser-safe functions here
      // DON'T include writeEnvFile or other Node.js functions
    };

    isInitialized = true;
    // console.log("Cwiggo SDK (browser-safe) initialized successfully");
    return sdkInstance;
  } catch (error) {
    console.error("Failed to initialize Cwiggo SDK:", error);
    return null;
  }
}

/**
 * Check if SDK is initialized
 */
export function isCwiggoSDKInitialized(): boolean {
  return isInitialized && sdkInstance !== null;
}

export async function helloWorld() {
  const sdk = await initializeSDK();
  if (!sdk || !sdk.helloWorld) {
    console.warn("SDK helloWorld not available");
    return;
  }

  return sdk.helloWorld();
}
